import { render, staticRenderFns } from "./TAmbience.vue?vue&type=template&id=0d581b7f&scoped=true&"
import script from "./TAmbience.vue?vue&type=script&lang=js&"
export * from "./TAmbience.vue?vue&type=script&lang=js&"
import style0 from "./TAmbience.vue?vue&type=style&index=0&id=0d581b7f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d581b7f",
  null
  
)

export default component.exports